import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ColorSwatch from "../../../components/ColorSwatch";
import ColorGrid from "../../../components/ColorGrid";
import styles from "./color.module.scss";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Color plays a critical role in the expression of the IBM Design Language. It’s a visual, visceral way to experience our brand and should communicate a sense of sophistication and warmth.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Blue at the core</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Accent color</AnchorLink>
    </AnchorLinks>
    <h2>{`Blue at the core`}</h2>
    <p>{`A vibrant set of blues is the centerpoint of our color palette. When combined with the simplicity of black and white, a refreshing and unique look emerges for IBM.`}</p>
    <p>{`Blue is emblematic of our identity and should be treated with the same attention and detail as we treat our logo. Blue should be the focal color accent within our Welcome and Arrival spaces. Application of blue within architectural finishes further amplifies our brand character in unique or unexpected touchpoints. Learn more about our `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/color/"
      }}>{`color palette`}</a>{`.`}</p>
    <div>
      <Row className={styles.blueAtCore} mdxType="Row">
        <Column colLg={6} colMd={4} mdxType="Column">
          <img {...{
            "src": "/workplace-xg/d2387b244aff8a7d8b3147d9be3d8020/ibm-logo.svg",
            "alt": "IBM logo in white on Blue 60 field",
            "title": "IBM logo in white on Blue 60 field"
          }}></img>
        </Column>
        <Column colLg={6} colMd={4} mdxType="Column">
          <img {...{
            "src": "/workplace-xg/19248d55070c0c7ce44320745db3cc02/rebus.svg",
            "alt": "IBM rebus in white on blue field",
            "title": "IBM rebus in white on blue field"
          }}></img>
        </Column>
      </Row>
      <ColorGrid colorFamily="blue" mdxType="ColorGrid" />
      <ColorGrid colorFamily="gray" mdxType="ColorGrid" />
    </div>
    <h2>{`Accent color`}</h2>
    <p>{`Color for all primary wall surfaces should be light and airy. It should evoke a feeling of warmth that works with our overall material palette. Combine white trim with subtle gray walls to create a sophisticated sense of depth. In spaces with core walls, use a color that creates a distinct contrast from the typical walls. Choose colors that complement the interior design from the palette shown here. In phone and conference rooms, an accent color may be used on the return walls to energize the space. Back walls should always be painted with a neutral tone in Gray or White.`}</p>
    <ColorSwatch formats={["PMS", "CMYK"]} swatchPalettes={[[{
      gray: [100, 90, 80, 30, 20, 10]
    }, {
      green: [20]
    }, {
      teal: [20]
    }, {
      cyan: [20]
    }, {
      purple: [20]
    }, {
      magenta: [20]
    }, {
      red: [20]
    }], [{
      cyan: [100]
    }, {
      blue: [60]
    }, {
      "warm gray": [30, 20, 10]
    }, {
      white: [0]
    }, {
      green: [10]
    }, {
      teal: [10]
    }, {
      cyan: [10]
    }, {
      purple: [10]
    }, {
      magenta: [10]
    }, {
      red: [10]
    }]]} mdxType="ColorSwatch" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      